import ImportantDateEventEnum from "../../../models/ImportantDate/ImportantDateEventEnum";

export const buildBootstrapRequestKey = ({
  applicantOib,
  childOibValue,
  eventId,
  pedagogicalYearId,
  institutionId,
  isPreschoolRequestRoute,
}: {
  applicantOib: string;
  childOibValue: string;
  eventId?: number;
  institutionId?: number;
  isPreschoolRequestRoute: boolean;
  pedagogicalYearId?: number;
}) => {
  return [
    isPreschoolRequestRoute ? "preschool" : "regular",
    applicantOib,
    childOibValue,
    eventId ?? "",
    pedagogicalYearId ?? "",
    institutionId ?? "",
  ].join(":");
};

export const getIsRequestCreationOpen = ({
  currentImportantDateEventId,
  currentPedagogicalYearId,
}: {
  currentImportantDateEventId?: number;
  currentPedagogicalYearId?: number;
}) => {
  return (
    !!currentPedagogicalYearId &&
    currentImportantDateEventId === ImportantDateEventEnum.RequestCreation
  );
};

export const getShouldFetchChildRequestCount = ({
  applicantOib,
  childOibValue,
  isImportantDateReady,
  isNewRequestRoute,
  isPedagogicalYearReady,
  isRequestCreationOpen,
}: {
  applicantOib?: string;
  childOibValue?: string;
  isImportantDateReady: boolean;
  isNewRequestRoute: boolean;
  isPedagogicalYearReady: boolean;
  isRequestCreationOpen: boolean | number;
}) => {
  return Boolean(
    isNewRequestRoute &&
      applicantOib &&
      childOibValue &&
      isImportantDateReady &&
      isPedagogicalYearReady &&
      isRequestCreationOpen,
  );
};
